export default __webpack_public_path__ + "static/media/ai_face_trackingActive.20a837ec.svg";